import { DividerModel } from '../../../../../shared/kiosk';
import { AbstractElementEditor } from './AbstractElementEditor';

export class DividerEditor extends AbstractElementEditor<DividerModel> {
  public getDescription(): string {
    return 'Horizontal bar to separate parts of the page';
  }

  public getName(): string {
    return 'Divider';
  }

  public getIcon(): string {
    return 'horizontal_rule';
  }
}
